<template>
    <tr class="fiscal-year-line">
        <td>
            {{ title }}
        </td>
        <td>
            <el-date-picker
                v-model="start"
                :class="[{ 'has-error': startError !== null }]"
                :format="datePickerFormat"
                valueFormat="YYYY-MM-DD"
                type="date"
                @change="$emit('update:modelValue', buildPeriods)"
            >
            </el-date-picker>
            <div v-if="startError !== null" class="error-msg">
                {{ startError }}
            </div>
        </td>
        <td>
            <i
                v-show="showDelete"
                class="el-icon-delete fs-4 mt-2"
                style="float: right"
                circle
                @click="$emit('remove', title)"
            ></i>

            <el-date-picker
                v-model="end"
                :class="[{ 'has-error': endError !== null }]"
                :format="datePickerFormat"
                valueFormat="YYYY-MM-DD"
                type="date"
                @change="$emit('update:modelValue', buildPeriods)"
            >
            </el-date-picker>
            <div v-if="endError !== null" class="error-msg">
                {{ endError }}
            </div>
        </td>
    </tr>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('corp');

export default {
    props: {
        title: {
            required: true,
            type: String,
        },
        startError: {
            required: false,
            default: null,
            type: String,
        },
        endError: {
            required: false,
            default: null,
            type: String,
        },
        showDelete: {
            required: true,
            type: Boolean,
        },
        modelValue: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            start: this.modelValue[0],
            end: this.modelValue[1],
        };
    },
    computed: {
        buildPeriods() {
            return [this.start, this.end];
        },
        ...mapGetters(['datePickerFormat']),
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.fiscal-year-line {
    // Reset CSS to match with Element.io
    .el-input__prefix,
    .el-input__suffix {
        top: -5px;
    }
    .el-date-editor .el-input__inner,
    .el-date-editor.el-input__inner {
        width: 220px;
        padding: 0 30px;
    }
    .el-button.is-circle {
        height: 40px;
        padding: 12px;
    }

    .has-error input {
        border-color: $red;
    }
    .error-msg {
        color: $red;
    }
}
</style>
